/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedVisitReviewListSchema } from '../models/PagedVisitReviewListSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ReviewsApi {
    /**
     * Delete Visit Review
     * Delete visit review. <br>Required Permission: delete_visit_review
     * @returns any OK
     * @throws ApiError
     */
    public static reviewsDeleteVisitReviewDelete({
        reviewId,
    }: {
        reviewId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/reviews/',
            query: {
                'review_id': reviewId,
            },
        });
    }
    /**
     * Get Visit Review List
     * Get list of visit reviews
     * @returns PagedVisitReviewListSchema OK
     * @throws ApiError
     */
    public static reviewsGetVisitReviewListGet({
        userId,
        serviceId,
        startDate,
        endDate,
        limit = 100,
        offset,
    }: {
        userId?: (string | null),
        serviceId?: (string | null),
        startDate?: (string | null),
        endDate?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedVisitReviewListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/reviews/',
            query: {
                'user_id': userId,
                'service_id': serviceId,
                'start_date': startDate,
                'end_date': endDate,
                'limit': limit,
                'offset': offset,
            },
        });
    }
}
